import { mixpanel } from '@fiverr-private/obs';
import {
    ACTION_NAMES,
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getCommonStores } from '../../utils/getCommonStores';

export const reportSellerAvatarClicked = () => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getCommonStores(),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.CHOOSE_VARIATION,
        [MIXPANEL_EVENT_PROPERTIES.ACTION]: ACTION_NAMES.CHOOSE_VARIATION_SELLER_CLICK_ACTION,
    });
};
